import { types } from "../types/types";
import { finishSpinner, startSpinner } from "./ui/spinner";
import ArchivosMigracionService from "../services/ArchivosMigracionService"
import { startAlerta } from "./ui/alertas";
import { handleErrorApi } from "../helpers/randoms";
import Axios from "axios";

const baseUrl = process.env.REACT_APP_API_URL;

export const setArchivosMigracion = (payload) => async (dispatch) => {
    dispatch({
        type: types.archivosMigracionSuccess,
        payload
    })
}

export const getArchivosMigracion = (fechaDesde, fechaHasta, tipoArchivo) => async (dispatch) => {
    dispatch(startSpinner());
    dispatch({ type: types.archivosMigracionTraer })
    try {
        const result = await ArchivosMigracionService.getArchivos(
            fechaDesde !== null ? fechaDesde.toISOString() : new Date('1970-01-01').toISOString(),
            fechaHasta !== null ? fechaHasta.toISOString() : new Date('2099-01-01').toISOString(),
            tipoArchivo)
        const body = await result.json()
        if (result.ok) {
            dispatch(finishSpinner());
            dispatch({
                type: types.archivosMigracionSuccess,
                payload: body
            })

        } else {
            throw body.errores
        }

    } catch (error) {
        dispatch(finishSpinner());
        dispatch({ type: types.archivosMigracionError })
        console.log("Error al traer los archivos de migracion", error)
        if (error?.mensaje) {
            dispatch(startAlerta(error.mensaje, "error"))
        } else {
            dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
        }
    }
}

export const getParametrosImportacion = () => async (dispatch) => {
    dispatch(startSpinner());
    dispatch({ type: types.parametrosImportacionTraer })
    try {
        const result = await ArchivosMigracionService.getParametrosImportacion()
        const body = await result.json()
        if (result.ok) {
            dispatch(finishSpinner());
            dispatch({
                type: types.parametrosImportacionSuccess,
                payload: body
            })

        } else {
            throw body.errores
        }

    } catch (error) {
        dispatch(finishSpinner());
        dispatch({ type: types.parametrosImportacionError })
        console.log("Error al traer los parametros de importacion", error)
        if (error.mensaje) {
            dispatch(startAlerta(error.mensaje, "error"))
        } else {
            dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
        }
    }
}

export const getNovedades = () => async (dispatch) => {
    dispatch({ type: types.archivosMigracionTraer })
    dispatch(startSpinner());
    try {
        const result = await ArchivosMigracionService.getNovedades()
        const body = await result.json()
        if (result.ok) {
            dispatch({
                type: types.novedadesSuccess,
                payload: body
            })
            dispatch(finishSpinner());
        } else {
            throw body.errores
        }

    } catch (error) {
        dispatch(finishSpinner());
        dispatch({ type: types.archivosMigracionError })
        console.log("Error al traer los archivos de migracion", error)
        if (error.mensaje) {
            dispatch(startAlerta(error.mensaje, "error"))
        } else {
            dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
        }
    }
}

export const postBajasNovedades = (jsonData) => {
    return async (dispatch) => {
        try {
            dispatch(startSpinner());
            const result = await ArchivosMigracionService.postBajasNovedades(
                jsonData
            );
            const body = await result.json();
            if (result.ok) {
                dispatch(startAlerta(`Se ejecuto correctamente el proceso`, "success", `Exito!`));
            } else {
                throw body;
            }
            dispatch(getNovedades());
        } catch (error) {
            dispatch(finishSpinner());
            handleErrorApi(
                dispatch,
                error,
                "Error al realizar las bajas",
                "Ha ocurrido un error. Intente nuevamente"
            );
        }
    };
};


export const subirArchivoMigracionNuevoHandler = (file, tipoArchivo) => {
    return async (dispatch) => {
        const formData = new FormData();
        formData.append("files", file);

        dispatch(subirArchivoMigracionNuevo(formData, tipoArchivo));
    };
};

export const subirArchivoMigracionNuevo = (formData, tipoArchivo) => {
    return async (dispatch) => {
        try {
            debugger
            dispatch(startSpinner());
            const token =
                localStorage.getItem("token") || sessionStorage.getItem("token") || "";
            let httpHeaders;
            if (token) {
                httpHeaders = {
                    Authorization: `Bearer ${token}`,
                };
            }
            const response = await fetch(
                `${baseUrl}/FileUpload/UploadFileAfiliacionesNuevo/${tipoArchivo}`,
                {
                    method: "POST",
                    body: formData,
                    headers: httpHeaders,
                }
            );

            const body = await response.json();
            if (response.ok) {
                dispatch(
                    startAlerta(
                        body.mensaje,
                        body.error === 0 ? "success" : "error",
                        body.error === 0 ? "Proceso Exitoso" : "Ocurrio un Error"
                    )
                );
            } else {
                throw body;
            }
            dispatch(finishSpinner());
        } catch (error) {
            dispatch(finishSpinner());
            handleErrorApi(
                dispatch,
                error,
                "Error al guardar el documento.",
                "Ha ocurrido un error. Intente nuevamente."
            );
        }
    };
};


export const subirArchivoMigracion = (file, tipoArchivo) => async (dispatch) => {
    dispatch(startSpinner());
    const url = `${baseUrl}/FileUpload/UploadFile/ArchivosMigracion/${tipoArchivo}`;
    const token = localStorage.getItem('token') || sessionStorage.getItem('token') || '';
    let httpHeaders;
    if (token) {
        httpHeaders = {
            Authorization: `Bearer ${token}`,
        };
    }
    const formData = new FormData();
    formData.append("files", file);

    try {
        const result = await fetch(url, {
            method: "POST",
            body: formData,
            headers: httpHeaders
        });
        const body = await result.json()

        if (result.ok) {
            dispatch(getArchivosMigracion())
            dispatch(finishSpinner());
        } else {
            throw body.errores;
        }
    } catch (error) {
        dispatch(finishSpinner());
        console.log(error);

        if (error.mensaje) {
            dispatch(startAlerta(error.mensaje, "error"))
        } else {
            dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
        }
    }
};

export const descargarPadronSSS = () => async (dispatch) => {
    const url = `${process.env.REACT_APP_API_URL}/ArchivosMigracion/DownloadPadronV3`;
    const token = localStorage.getItem('token') || sessionStorage.getItem('token') || '';
    let httpHeaders;
    if (token) {
        httpHeaders = {
            Authorization: `Bearer ${token}`,
        };
    }
    try {
        dispatch(startSpinner());
        Axios({
            url: url,
            method: 'GET',
            responseType: 'blob',
            headers: httpHeaders,
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'padron_sss.zip');
            document.body.appendChild(link);
            link.click();
            dispatch(finishSpinner());
        });
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al descargar el archivo", "Ha ocurrido un error. Intente nuevamente")
    }
}